
define('modules/application/wizard/classes/radioSensors',[
    "app",

    // Libs
    "backbone",

    // Classes
    "./genericCollectionSection"

  ],

  function(app, Backbone, genericCollectionSection) {
    var genericCollectionItemEvents = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
    var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {

      View: genericCollectionSection.genericCollectionItem.View.extend({
        tagName: "li",
        className: "radioSensors",
        template: "application/wizard/sections/genericCollectionSection/radioSensors",
        events: _.extend(genericCollectionItemEvents, {
          "change .type": "typeChangedEventHandler",
          "keyup input[name='description']": "descriptionChangedEventHandler"
        }),
        initialize: function() {
          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          this.model.unbind("change:number", this.render);
          this.model.bind("change:number", this.render, this);
        },
        typeChangedEventHandler: function(e) {
          var type = e.currentTarget.value;

          //Update the model
          this.model.set("type", type);
        },
        descriptionChangedEventHandler: function(e) {
          this.model.set("description", e.currentTarget.value);
        }
      }),

      Model: genericCollectionSection.genericCollectionItem.Model.extend({
        defaults: {
          number: -1,
          selected: false,
          description: ""
        },
        initialize: function() {
          genericCollectionSection.genericCollectionItem.Model.prototype.initialize.apply(this);
          this.fetchPackages();
          this.bind("change:type", this.typeChangedEventHandler, this);

          if (this.get("type"))
            this.typeChangedEventHandler();
          else
            this.set("type", this.get("fetchedPackages")[0].packageClassId);
        },
        typeChangedEventHandler: function() {
          var type = this.get("type"),
            that = this;

          //Merging with wizard package attributes
          var wizardAttributes = _.filter(that.get("fetchedPackages"), function(pack) {
            return pack.packageClassId === type;
          });

          if (wizardAttributes.length === 1)
            wizardAttributes = wizardAttributes[0];
          _.extend(this.attributes, wizardAttributes);

          //Merging with item's attributes
          if ((type) && (type !== "")) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(type, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });
              products = products[0];
              _.extend(that.attributes, products);

              that.set("secondaryProducts", secondaryProducts);
            });
          } else {
            this.resetValues();
          }

          that.trigger("render:requested");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },
        resetValues: function() {
          this.set("catalogId", undefined);
          this.set("description", undefined);
          this.set("image", undefined);
          this.set("links", undefined);
          this.set("mnemonic", undefined);
          this.set("optionalPackages", undefined);
          this.set("packageActuator", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
          this.set("packageInDepth", undefined);
          this.set("packageLoad", undefined);
          this.set("price", undefined);
          this.set("productCode", undefined);
          this.set("productDescription", undefined);
          this.set("productInDepth", undefined);
          this.set("productLabel", undefined);
          this.set("specialVars", undefined);
          this.set("wizardChoiceDescription", undefined);
          this.set("wizardChoiceLabel", undefined);
          this.set("packageClassDescription", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
        },
        fetchPackages: function() {
          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            var that = this;
            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(411, function(data) {
              that.set("fetchedPackages", data.packages);
            });
          }
        },
        deliverCurrent: function() {
          if (this.get("specialVars")) {
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
            var currentConsumption = $.parseJSON(this.get("specialVars")).currentConsumption;
            if (currentConsumption < 0)
              consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
          }
        }
      })

    });

    var radioSensors = _.extend({}, genericCollectionSection, {

      Views: {
        titleBar: genericCollectionSection.Views.titleBar.extend(),
        content: genericCollectionSection.Views.content.extend({
          template: "application/wizard/sections/genericCollectionSection/collectionWithInfo",
          events: _.extend(_.extend({}, genericCollectionSection.Views.content.prototype.events), {
            "click .toggleInfoButton": "toggleInfos"
          }),
          toggleInfos: function(e) {
            return genericCollectionSection.Views.content.prototype.toggleInfos(e, this);
          },

          initialize: function() {
            genericCollectionSection.Views.content.prototype.initialize.apply(this);
            this.model.bind("render:requested", this.renderRequestedEventHandler, this);
          },

          renderRequestedEventHandler: function() {
            this.render();
          },

          addItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.addItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              this.insertView(".elements", viewToAdd);
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          beforeRender: function() {
            var i = 0;
            if ((this.model.get("collection")) && (BticinoS4B.Instances.Models.ApplicationModel.get("radioSystemPresent"))) {
              var collection = this.model.get("collection"),
                collectionLength = collection.models.length;
              var collectionItemView = genericCollectionItem.View;
              for (i = 0; i < collectionLength; i++) {
                this.insertView(".elements", new collectionItemView({
                  model: collection.models[i]
                }));
              }
            }
          },

          afterRender: function() {
            if (!BticinoS4B.Instances.Models.ApplicationModel.get("radioSystemPresent")) {
              this.$el.html("<h4 class='alert'>" + $.i18n._("IDS_WAI1001_9017") + "</h4>");
            } else if ((this.model.get("collection")) && (this.model.get("collection").length === 0))
              this.$el.append("<h4 class='alert'>" + $.i18n._("IDS_WAI1001_9018") + "</h4>");
            window.customizeFormElements.call();
          }
        })
      },

      Model: genericCollectionSection.Model.extend({
        defaults: _.extend({
          name: "IDS_WAI8_10",
          collectionEventAggregator: _.extend({}, Backbone.Events),
          infoQuote: "IDS_WGENTT_000024"
        }, genericCollectionSection.Model.prototype.defaults),

        initialize: function() {
          genericCollectionSection.Model.prototype.initialize.apply(this);
          //Declarations
          this.set("radioSystemPresent", BticinoS4B.Instances.Models.ApplicationModel.get("radioSystemPresent"));
          var collectionItemModel = genericCollectionItem.Model;
          var collectionModel = Backbone.Collection.extend({
            model: collectionItemModel
          });
          var collection, oldCollection;

          //Perimetral protection zone events
          this.get("zoneEventAggregator").unbind("perimetralProtection:changed", this.perimetralProtectionChangedEventHandler);
          this.get("zoneEventAggregator").bind("perimetralProtection:changed", this.perimetralProtectionChangedEventHandler, this);

          //Volumetric protection zone events
          this.get("zoneEventAggregator").unbind("volumetricProtection:changed", this.volumetricProtectionChangedEventHandler);
          this.get("zoneEventAggregator").bind("volumetricProtection:changed", this.volumetricProtectionChangedEventHandler, this);

          //Lengths communication events
          this.get("zoneEventAggregator").unbind("communicate:lengths", this.lengthsCommunicationRequested);
          this.get("zoneEventAggregator").bind("communicate:lengths", this.lengthsCommunicationRequested, this);
          this.set("radioSystemPresent", BticinoS4B.Instances.Models.ApplicationModel.get("radioSystemPresent"));

          if (this.get("collection")) {

            //Creating new event aggragator
            collectionEventAggregator = _.extend({}, Backbone.Events);

            //Creating a new collection and storing the original one
            if (this.get("collection")) {
              oldCollection = this.get("collection");

              if (oldCollection.models)
                oldCollection = oldCollection.models;
            }

            this.set("collection", new collectionModel());
            collection = this.get("collection");

            if (oldCollection) {
              for (i = 0; i < oldCollection.length; i++) {
                if (!oldCollection[i].attributes)
                  this.addItem(_.extend({
                    collectionEventAggregator: this.get("collectionEventAggregator")
                  }, oldCollection[i]));
                else
                  collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
              }
            }

            if (collection.length < this.get("minItem"))
              this.addItem();
          } else
            this.set("collection", new collectionModel());

          this.get("collectionEventAggregator").bind("selectedItem:changed", this.selectedItemChangedEventHandler, this);

          window.BticinoS4B.eventAggregator.bind("radioSystemPresent:changed", this.radioSystemStatusPresenceChangedEventHandler, this);
          window.BticinoS4B.eventAggregator.bind("model:deliver", this.deliverModel, this);

          if ((!this.get("volumetricProtectionLength")) || (!this.get("perimetralProtectionLength"))) {
            this.get("zoneEventAggregator").trigger("communicate:lengths");
          }

          this.trigger("render:requested");
        },

        lengthsCommunicationRequested: function() {
          if (this.get("collection"))
            this.get("zoneEventAggregator").trigger("radioSensors:changed", this.get("collection").models.length);
          else
            this.get("zoneEventAggregator").trigger("radioSensors:changed", 0);
        },

        perimetralProtectionChangedEventHandler: function(perimetralProtections) {
          this.set("perimetralProtectionLength", perimetralProtections);
          this.recalculateStartNumber();
        },

        volumetricProtectionChangedEventHandler: function(volumetricProtections) {
          this.set("volumetricProtectionLength", volumetricProtections);
          this.recalculateStartNumber();
        },

        recalculateStartNumber: function() {
          var perimetralProtectionLength = this.get("perimetralProtectionLength") ? this.get("perimetralProtectionLength") : 0;
          var volumetricProtectionLength = this.get("volumetricProtectionLength") ? this.get("volumetricProtectionLength") : 0;
          var startNumber = perimetralProtectionLength + volumetricProtectionLength + 1;
          this.set("startNumber", startNumber);
          this.sortItems();
        },

        instanceCollection: function() {
          var collectionItemModel = genericCollectionItem.Model;
          var collectionModel = Backbone.Collection.extend({
            model: collectionItemModel
          });

          this.set("collection", new collectionModel());
          this.get("zoneEventAggregator").trigger("radioSensors:changed", this.get("collection").models.length);
          collection = this.get("collection");

          if (collection.models.length < this.get("minItem"))
            this.addItem();
          this.trigger("updateViews", collection.length);
        },

        resetCollection: function() {
          var collection = this.get("collection");
          BticinoS4B.Instances.Models.ApplicationModel.set("radioSensorsLength", 0);

          if (collection)
            collection.reset();
        },

        addItem: function(itemModel) {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var volumetricProtectionLength = this.get("volumetricProtectionLength") ? this.get("volumetricProtectionLength") : 0;
          var perimetralProtectionLength = this.get("perimetralProtectionLength") ? this.get("perimetralProtectionLength") : 0;
          var defaultItem;
          //Per quando si cambiano i contatti dalla centrale
          this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
          this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
          this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
          this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);

          if ((collectionLength + volumetricProtectionLength + perimetralProtectionLength + 1) <= this.get("maxItem")) {
            var collectionItemModel = genericCollectionItem.Model;
            if (itemModel)
              defaultItem = new collectionItemModel(itemModel);
            else
              defaultItem = new collectionItemModel({
                number: this.getNewNumber(),
                collectionEventAggregator: this.get("collectionEventAggregator")
              });

            collection.add(defaultItem);
            defaultItem.set("selected", true);
            this.sortItems();
            this.trigger("updateViews", collection.length);
            this.get("zoneEventAggregator").trigger("radioSensors:changed", this.get("collection").models.length);

            //Trigger event for zone validation
            this.trigger("item:added");
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            return defaultItem;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        duplicateItem: function(modelToDuplicate) {
          var collectionItemModel = genericCollectionItem.Model;
          var itemNumber = this.getNewNumber(),
            modelToAdd;
          var collection = this.get("collection"),
            collectionLength = collection.length;
            //Per quando si cambiano i contatti dalla centrale
            this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
            this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
            this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
            this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);
          var selectedModels = collection.filter(function(item) {
            return item.get("selected");
          });
          var volumetricProtectionLength = this.get("volumetricProtectionLength") ? this.get("volumetricProtectionLength") : 0;
          var perimetralProtectionLength = this.get("perimetralProtectionLength") ? this.get("perimetralProtectionLength") : 0;

          if ((collectionLength + volumetricProtectionLength + perimetralProtectionLength + 1) <= this.get("maxItem")) {
            if (modelToDuplicate) {
              modelToAdd = new collectionItemModel($.extend(true, {}, modelToDuplicate.attributes));
              if (modelToDuplicate) {
                modelToAdd.set("number", itemNumber);
                collection.add(modelToAdd);
                this.trigger("updateViews", this.get("collection").length);
                this.get("zoneEventAggregator").trigger("radioSensors:changed", this.get("collection").models.length);

                this.sortItems();

                //Trigger event for zone validation
                this.trigger("item:added", modelToAdd);
                this.trigger("render:requested");

                window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

                return modelToDuplicate;
              } else
                return false;
            } else
              return false;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        sortItems: function() {
          var collection = this.get("collection"),
            collectionLength = collection ? collection.length : 0;
          var i = 0;

          for (i = 0; i < collectionLength; i++) {
            collection.models[i].set("number", (this.get("startNumber") + i));
            if (i === (collectionLength - 1))
              collection.models[i].set("selected", true);
          }
        },

        removeItem: function(modelToRemove, silent) {
          var collection = this.get("collection");

          if (modelToRemove) {
            if (this.deleteItem(modelToRemove, silent)) {
              this.get("zoneEventAggregator").trigger("radioSensors:changed", this.get("collection").models.length);
              this.sortItems();
              this.trigger("updateViews", this.get("collection").length);

              //Trigger event for zone validation
              this.trigger("item:removed");
              this.trigger("render:requested");
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              return modelToRemove;
            }
          } else
            return false;
        },

        radioSystemStatusPresenceChangedEventHandler: function() {
          this.set("radioSystemPresent", BticinoS4B.Instances.Models.ApplicationModel.get("radioSystemPresent"));
          if (this.get("radioSystemPresent"))
            this.instanceCollection();
          else
            this.resetCollection();

          this.trigger("render:requested");
        },

        getNewNumber: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          return this.get("startNumber") + collectionLength + 1;
        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.radioSensorsModel = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.radioSensorsModel = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.radioSensorsModel = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.radioSensorsModel = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.radioSensorsModel = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.radioSensorsModel = this;
              break;
          };
          BticinoS4B.Instances.Models.ApplicationModel.set("radioSensorsModel", this);
        },

        deliverCurrent: function() {
          var collection = this.get("collection"),
            collectionLength = collection ? collection.length : 0;
          var i = 0;

          for (i = 0; i < collectionLength; i++)
            collection.models[i].deliverCurrent();
        }
      }),
      genericCollectionItem: genericCollectionItem
    });

    // Required, return the module for AMD compliance
    return radioSensors;

  });